import React, { useEffect } from 'react';
import { Form, FormInstance } from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../grid';
import { CardBlock } from '../../organisms/card';
import SelectMethod from '../../organisms/schedule/method';
import Button from '../../molecules/button';
import Icon from '../../atoms/icon';
import { faSave } from '@fortawesome/pro-solid-svg-icons';

interface SurveyData {
  type: string;
}

export const QualitySurveyDefaultData: SurveyData = {
  type: 'message'
};

interface QualitySurveyFormProps {
  setForm?: (form: FormInstance<SurveyData>) => void;
  onSubmit?: (data: SurveyData) => void;
  isDisabled?: boolean;
}

const QualitySurveyForm = ({
  setForm,
  onSubmit: _onSubmit,
  isDisabled
}: QualitySurveyFormProps): JSX.Element => {
  const form = new FormInstance<SurveyData>(QualitySurveyDefaultData);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: SurveyData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit} disabled={isDisabled}>
        <CardBlock>
          <Row>
            <Col sm={24}>
              <SelectMethod isSurvey />
            </Col>
          </Row>
        </CardBlock>
        <CardBlock>
          <Button intent="success" type="submit">
            <Icon icon={faSave} className="mr-2" /> Update Survey
          </Button>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default QualitySurveyForm;
